export const formatExpiry = value => {
    if (value.length === 1) {
        return value === "1" || value === "0" ? value : `0${value}`;
    }

    const cleaned = value.replace(/\D/g, "").slice(0, 6);
    if (cleaned.length < 3) return cleaned;
    return `${cleaned.slice(0, 2)}/${cleaned.slice(2)}`;
};
